import { useState, useCallback } from 'react';
import { Plan, PlanOption } from './types';

const initialPlan: Plan = {
  data: 1,
  voice: 100,
  sms: 100,
};

const planOptions: PlanOption[] = [
  { name: 'data', value: 1, min: 1, max: 100, step: 1, unit: 'GB', pricePerUnit: 1 },
  { name: 'voice', value: 100, min: 0, max: 1000, step: 10, unit: 'minutes', pricePerUnit: 0.1 },
  { name: 'sms', value: 100, min: 0, max: 1000, step: 10, unit: 'messages', pricePerUnit: 0.05 },
];

export const usePlanBuilder = () => {
  const [plan, setPlan] = useState<Plan>(initialPlan);

  const updatePlan = useCallback((name: keyof Plan, value: number) => {
    setPlan((prevPlan) => ({ ...prevPlan, [name]: value }));
  }, []);

  const calculateTotalCost = useCallback(() => {
    return planOptions.reduce((total, option) => {
      return total + plan[option.name as keyof Plan] * option.pricePerUnit;
    }, 0);
  }, [plan]);

  const calculateCoolnessFactor = useCallback(() => {
    const maxCoolness = planOptions.reduce((sum, option) => sum + option.max, 0);
    const currentCoolness = Object.values(plan).reduce((sum, value) => sum + value, 0);
    return (currentCoolness / maxCoolness) * 100;
  }, [plan]);

  return {
    plan,
    planOptions,
    updatePlan,
    calculateTotalCost,
    calculateCoolnessFactor,
  };
};